export const eventLocations = {
  nsw: { value: 'NSW', label: 'NSW' },
  act: { value: 'ACT', label: 'ACT' },
  vic: { value: 'VIC', label: 'VIC' },
  qld: { value: 'QLD', label: 'QLD' },
  sa: { value: 'SA', label: 'SA' },
  wa: { value: 'WA', label: 'WA' },
  tas: { value: 'TAS', label: 'TAS' },
  nt: { value: 'NT', label: 'NT' },
  online: { value: 'ONLINE', label: 'Online' }
};



// WEBPACK FOOTER //
// ./src/constants/locations.js